import { render, staticRenderFns } from "./partyManage.vue?vue&type=template&id=55fa447b&scoped=true"
import script from "./partyManage.vue?vue&type=script&lang=js"
export * from "./partyManage.vue?vue&type=script&lang=js"
import style0 from "./partyManage.vue?vue&type=style&index=0&id=55fa447b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa447b",
  null
  
)

export default component.exports